var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"row columns",class:_vm.customClasses},'div',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.columns),function(colKey){return [(_vm.$slots[colKey])?_c('div',{key:colKey,class:`col-${_vm.columnAttributes[colKey].cols}`},[_vm._t(colKey)],2):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }